/**
 * socket-client.ts
 * Client-only wrapper for socket.io-client
 */

export async function getSocketIOClient() {
  const { io } = await import('socket.io-client');
  return io;
}

export type { Socket } from 'socket.io-client';
